@if (!isLoading) {
  <div class="flex flex-col w-full gap-8 p-2">
    @if (!contextService.widgetFeatures.showAdditionalFaxButtons) {
      <div>
        <div class="field">
          <label class="field-required">
            <span class="pl-1">Select Form:</span>
          </label>
          <div class="p-field-value">
            <p-select
              appendTo="body"
              dataKey="documentTypeId"
              optionLabel="documentDisplayName"
              placeholder="Select Form"
              [options]="documentTypes"
              [(ngModel)]="documentType"
              (onChange)="loadForm()"
            />
          </div>
        </div>
      </div>
    }
    @if (contextService.widgetFeatures.showAdditionalFaxButtons) {
      <div class="flex gap-4 flex-wrap w-full items-center">
        <div class="field mb-0!">
          <label class="field-required pr-2" data-test-id="select-form-label">
            Select Form:
          </label>
          <p-select
            appendTo="body"
            dataKey="documentTypeId"
            optionLabel="documentDisplayName"
            placeholder="Select Form"
            [options]="documentTypes"
            [(ngModel)]="documentType"
            (onChange)="loadForm()"
          />
        </div>
        <ng-container>
          <div>
            @if (documentType) {
              <button
                severity="secondary"
                aria-label="View Service Lines"
                size="small"
                data-test-id="view-service-lines-button"
                icon="pi pi-calendar"
                label="View Service Lines"
                pButton
                type="button"
                (click)="openNotes('serviceLines')"
              >
              </button>
            }
          </div>
          <div>
            @if (documentType) {
              <button
                severity="secondary"
                aria-label="View Document"
                size="small"
                data-test-id="view-documents-button"
                icon="pi pi-folder-open"
                label="View Documents"
                pButton
                type="button" (click)="openDocuments()">
              </button>
            }
          </div>
        </ng-container>
      </div>
    }
    <div aria-label="send-fax-form">
      <ng-container #slot/>
    </div>
    @if (isFaxReady) {
      <div class="p-2">
        <button
          aria-label="Send Fax"
          class="pull-right"
          label="Send"
          pButton
          type="button"
          [disabled]="isLoading"
          (click)="preSendFax()">
        </button>
        @if (isLoading) {
          <p-progressSpinner class="pull-right"/>
        }
      </div>
    }
    <p-dialog
      appendTo="body"
      header=""
      [closable]="false"
      [maximizable]="false"
      [minY]="70"
      [modal]="true"
      [style]="{ width: '400px', minWidth: '200px' }"
      [(visible)]="showCancelModal"
    >
      <p>The member is inactive, do you wish to continue?</p>
      <ng-template #footer>
        <button
          aria-label="Cancel send fax confirmation"
          class="no-focus p-button-secondary p-button-padding dme-small-action-button"
          icon=""
          label="Cancel"
          pButton
          type="button"
          (click)="showCancelModal=false"
        ></button>
        <button
          aria-label="Confirm send fax"
          class="p-button-padding dme-small-action-button"
          icon=""
          label="Continue"
          pButton
          type="button"
          (click)="confirmSend()"
        ></button>
      </ng-template>
    </p-dialog>
  </div>
} @else {
  <div class="grid grid-cols-12 gap-4">
    <p-progressSpinner/>
  </div>
}

